import { connect } from "react-redux";
import { capitalize } from "../../utils/string";

const CoupleInfo = ({ data = {}, isFromPortfolio = false, isGroom, pathname }) => {
    return (
        <>
            <h3>{capitalize(data.name)}</h3>
            <p>
                {isGroom ? "S/o" : "D/o"} {capitalize(data.fatherName)}{" "}
                {data.motherName && data.motherName !== "" && (
                    <span className="mother-name">
                        and{" "}  {capitalize(data.motherName)}
                    </span>
                )}
            </p>
            {pathname?.includes("Etasha-Pulkit") && <p>
                {isGroom
                    ? "Grand S/o Late Shri Dalchand Ji Bhandari & Late Smt. Khyali Bai Ji Bhandari"
                    : "Grand D/o Late Smt. Kamla Devi & Late Shri Basantilal Choudhary"}
            </p>}

            {data.nativePlace && (
                <p style={{ marginTop: "-15px" }}>
                    From {data.nativePlace}
                </p>
            )}
            {data.phone && !isFromPortfolio && (
                <p style={{ marginTop: "-15px" }}>
                    <i className="fi flaticon-phone-call" />
                    {data.phone}
                </p>
            )}
            {data.about && <> <h3 className="orangeText" style={{ fontSize: "18px" }}>Meet the {isGroom ? "Groom" : "Bride"}</h3>
                <p>{data.about || ""}</p></>}
        </>
    )
}


const mapStateToProps = (state) => {
    return {
        isFromPortfolio: state.common?.isFromPortfolio,
        pathname:
            state.inviteDetails.invite?.pathname,
    };
};
export default connect(mapStateToProps)(CoupleInfo);
